/* Copyright Levelise Ltd 2020-2024 */
import config from '../config';

const UserService = {
    saveUser(user) {
        localStorage.setItem(config.User, JSON.stringify(user));
    },

    getUser() {
        const user = localStorage.getItem(config.User);
        return user ? JSON.parse(user) : null;
    },

    removeUser() {
        localStorage.removeItem(config.User);
    },
    
    saveUserDetail(detail) {
        localStorage.setItem(config.userDetail, JSON.stringify(detail));
    },

    getUserDetail() {
        const detail = localStorage.getItem(config.userDetail);
        return detail ?  JSON.parse(detail) : null;
    },

    removeUserDetail() {
        localStorage.removeItem(config.userDetail);
    },

    hasUser() {
        return !!localStorage.getItem(config.User);
    },

    getUsername() {
        return UserService.hasUser() ? UserService.getUser().username  : '';
    },

    isAdmin() {
        if (UserService.hasUser()) {
            return UserService.getUser()[config.Role].includes(config.Role_Admin);
        }
        return false;
    },

    hasPreferences() {
        return !!localStorage.getItem(config.preferences);
    },

    setPreferences(preferences) {
        localStorage.setItem(config.preferences, JSON.stringify(preferences));
    },

    getPreferences() {
        const preference = localStorage.getItem(config.preferences);
        return preference ? JSON.parse(preference) : null;
    },

    removePreferences() {
        localStorage.removeItem(config.preferences);
    },

    hasSubscriptions() {
        return !!localStorage.getItem(config.subscriptions);
    },

    setSubscriptions(subscriptions) {
        localStorage.setItem(config.subscriptions, JSON.stringify(subscriptions));
    },

    getSubscriptions() {
        const preference = localStorage.getItem(config.subscriptions);
        return preference ? JSON.parse(preference) : null;
    },

    removeSubscriptions() {
        localStorage.removeItem(config.subscriptions);
    },
}

export default UserService